export default [{
  name: 'coupons/list',
  path: '/coupons/list',
  meta: {
    needLogin: true
  },
  component: () => import('@/view/coupons/list.vue')
}, {
  name: 'coupon/one',
  path: '/coupons/:id',
  meta: {
    needLogin: true
  },
  component: () => import('@/view/coupons/coupon.vue')
}]